import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../common/CmnContext';
import { SaleListContext } from '../SaleListContext';


export function SaleListBanner(props: any) {
  const banner = props.banner;
  const bannerSale = props.bannerSale;

  const isPc = useContext(cmnContext).isPc;

  const [isDisp, setIsDisp] = useState<boolean>(false);

  // 詳細表示
  const setDetailSale = useContext(SaleListContext).setDetailSale;



  // 表示判定
  useEffect(() => {
    if(
      banner?.img &&
      (bannerSale || banner?.link)
    ) {
      setIsDisp(true);
    } else {
      setIsDisp(false);
    }
  }, [banner])


  const onClick = () => {
    if(bannerSale) {
      // 動画：詳細表示
      setDetailSale(bannerSale);
    } else if(banner?.link) {
      // 他ページへ遷移
      window.location.href = banner.link;
    }
  }


  return (
    <>
    {isDisp &&
      <div
        style={{
          width: '100%',
          padding: isPc? '20px 27%' : '20px 3%',
          backgroundColor: '#a6b78b',
        }}
        onClick={onClick}
      >

        <img
          src={banner.img}
          style={{
            width: '100%',
            objectFit: 'contain',
            border: '1px solid #000',
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.5)',
            borderRadius: '8px',
          }}
        />

      </div>
    }
    </>
  );
}